import { Component } from '@angular/core';

@Component({
  selector: 'app-price-monitoring-tasks-file-preview',
  standalone: false,
  templateUrl: './price-monitoring-tasks-file-preview.component.html'
})
export class PriceMonitoringTasksFilePreviewComponent {

}
